import type { BadgeTono } from "@/components";
import type { Noticia, TipoNoticia } from "./api";

/** Novedades del emprendimiento (Inicio del fiduciante): lógica pura. */

export const ETIQUETA_TIPO_NOTICIA: Record<TipoNoticia, string> = {
  obra: "Obra",
  gasto: "Gasto",
  pago: "Pago",
  terreno: "Terreno",
  prevision: "Previsión",
  venta: "Venta",
};

export const TONO_TIPO_NOTICIA: Record<TipoNoticia, BadgeTono> = {
  obra: "primario",
  gasto: "neutro",
  pago: "exito",
  terreno: "alerta",
  prevision: "alerta",
  venta: "exito",
};

/** De a cuántas se piden: "Ver más" suma otras tantas. */
export const NOTICIAS_POR_PAGINA = 20;

/** Adónde lleva tocar la novedad: la ficha del gasto, el avance, el proyecto o la cuenta; null si no hay más para ver. */
export function rutaNoticia(n: Pick<Noticia, "tipo" | "gasto_id">): string | null {
  if (n.gasto_id !== null) return `/gastos/${n.gasto_id}`;
  if (n.tipo === "obra") return "/avance";
  if (n.tipo === "venta") return "/proyecto";
  if (n.tipo === "prevision") return "/mi-cuenta";
  return null;
}
